/**
 * @license
 * Copyright Alibaba.com All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

export default {
  today: 'Ãro',
  now: 'Niha',
  backToToday: 'Vegere Ã®ro',
  ok: 'Temam',
  clear: 'Paqij bike',
  month: 'Meh',
  year: 'Sal',
  timeSelect: 'DemÃª hilbijÃªre',
  dateSelect: 'DÃ®rok hilbijÃªre',
  monthSelect: 'Meh hilbijÃªre',
  yearSelect: 'Sal hilbijÃªre',
  decadeSelect: 'Dehsal hilbijÃªre',
  yearFormat: 'YYYY',
  dateFormat: 'D/M/YYYY',
  dayFormat: 'D',
  dateTimeFormat: 'D/M/YYYY HH:mm:ss',
  monthBeforeYear: true,
  previousMonth: 'Meha peÅ (PageUp))',
  nextMonth: 'Meha paÅ (PageDown)',
  previousYear: 'Sala peÅ (Control + Åep)',
  nextYear: 'Sala paÅ (Control + rast)',
  previousDecade: 'Dehsalen peÅ',
  nextDecade: 'Dehsalen paÅ',
  previousCentury: 'Sedsalen peÅ',
  nextCentury: 'Sedsalen paÅ'
};
